import { SourcePageCell } from './SourcePageCell';
import { Td, Th, TruncatedTd } from './cells';
import { FindingMarkerCell, FindingMarkerHeader, type RowFindings } from './FindingMarkerCell';
import {
  extractionRowClass,
  extractionTableClass,
  extractionTbodyClass,
  extractionTheadClass,
} from './tableClasses';
import {
  formatBillOfSaleSigned,
  type BillOfSalePresentationRow,
} from './billOfSalePresentation';

type BillOfSaleRow = BillOfSalePresentationRow;

export function BillOfSaleTable({
  rows,
  pageIdToPosition,
  onInspect,
  rowFindings,
}: {
  rows: BillOfSaleRow[];
  pageIdToPosition?: Map<string, number>;
  onInspect: (row: BillOfSaleRow, index: number) => void;
  rowFindings?: RowFindings;
}) {
  return (
    <table className={extractionTableClass}>
      <thead className={extractionTheadClass}>
        <tr>
          {rowFindings && <FindingMarkerHeader />}
          {pageIdToPosition && <Th>Page</Th>}
          <Th>Type</Th>
          <Th>Date</Th>
          <Th>ESN</Th>
          <Th>Seller</Th>
          <Th>Purchaser</Th>
          <Th>Signed</Th>
        </tr>
      </thead>
      <tbody className={extractionTbodyClass}>
        {rows.map((r, i) => (
          <tr
            key={`${r.pageId}-${i}`}
            onClick={() => onInspect(r, i)}
            className={extractionRowClass}
          >
            {rowFindings && <FindingMarkerCell findings={rowFindings.get(i)} />}
            {pageIdToPosition && (
              <Td>
                <SourcePageCell pageId={r.pageId} pageIdToPosition={pageIdToPosition} />
              </Td>
            )}
            <Td>{r.eventType}</Td>
            <Td>{r.date ?? '—'}</Td>
            <Td className="font-mono">{r.esn ?? '—'}</Td>
            <TruncatedTd value={r.seller} />
            <TruncatedTd value={r.purchaser} />
            <Td>{formatBillOfSaleSigned(r.isDocumentSigned)}</Td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
